/**
 * FbtWidget — "Completează cu" bundle selector
 * ES6+ class, BEM-aware, integrates with Spratly / Shopify cart API.
 */
class FbtWidget {
  constructor(el) {
    this._el            = el;
    this._productFormId = el.dataset.productFormId;
    this._items         = Array.from(el.querySelectorAll('[data-variant-id]'));
    this._addBtn        = el.querySelector('[data-fbt-add]');
    this._totalEl       = el.querySelector('.fbt__summary-total');
    this._compareEl     = el.querySelector('.fbt__summary-compare');
    this._savedRow      = el.querySelector('.fbt__summary-saved');
    this._savedEl       = el.querySelector('.fbt__summary-saved-amount');

    this._bindEvents();
    this._updateSummary();
  }

  // —— Private helpers —————————————————————————————————————————

  get _productForm() {
    return document.getElementById(this._productFormId);
  }

  /** Live variant ID from the product form (updated by variant picker). */
  get _currentVariantId() {
    const input = this._productForm && this._productForm.querySelector('input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  _formatMoney(cents) {
    const fmt = window.spratlyThemeSettings && window.spratlyThemeSettings.money_format;
    if (window.Shopify && window.Shopify.formatMoney && fmt) {
      return window.Shopify.formatMoney(cents, fmt);
    }
    return new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2 }).format(cents / 100) + ' lei';
  }

  _selectedItems() {
    return this._items.filter(el => el.classList.contains('fbt__item--selected'));
  }

  // —— Events ———————————————————————————————————————————————————

  _bindEvents() {
    this._el.querySelectorAll('.fbt__item-toggle').forEach(btn => {
      btn.addEventListener('click', () => this._toggle(btn));
    });

    this._addBtn.addEventListener('click', () => this._addToCart());
  }

  _toggle(btn) {
    const item     = btn.closest('[data-variant-id]');
    const selected = item.classList.toggle('fbt__item--selected');

    btn.classList.toggle('fbt__item-toggle--active', selected);
    btn.textContent = selected ? 'Selectat' : 'Adaugă';

    this._updateSummary();
  }

  // —— Summary ——————————————————————————————————————————————————

  _updateSummary() {
    let total = 0;
    let compare = 0;

    this._selectedItems().forEach(el => {
      const price  = parseInt(el.dataset.price, 10)        || 0;
      const cprice = parseInt(el.dataset.comparePrice, 10) || 0;
      total   += price;
      compare += cprice > price ? cprice : price;
    });

    this._totalEl.textContent = this._formatMoney(total);

    if (compare > total) {
      this._compareEl.textContent  = this._formatMoney(compare);
      this._compareEl.hidden       = false;
      this._savedEl.textContent    = this._formatMoney(compare - total);
      this._savedRow.hidden        = false;
    } else {
      this._compareEl.hidden = true;
      this._savedRow.hidden  = true;
    }
  }

  // —— Add to cart ——————————————————————————————————————————————

  async _addToCart() {
    const selected = this._selectedItems();
    if (!selected.length) return;

    const items = selected.map(el => ({
      // For the current product use the live variant from the product form
      id: el.classList.contains('fbt__item--current')
        ? (this._currentVariantId || parseInt(el.dataset.variantId, 10))
        : parseInt(el.dataset.variantId, 10),
      quantity: 1,
    }));

    this._addBtn.setAttribute('aria-busy', 'true');
    this._addBtn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items }),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data  = await res.json();
      const added = data.items || [];

      // Trigger theme cart drawer — same pattern used by the theme's own ATC
      if (window.Shopify && window.Shopify.onItemAdded && added.length) {
        window.Shopify.onItemAdded(added[0]);
        added.slice(1).forEach(item => window.Shopify.onItemAdded(item, false));
      }
    } catch (err) {
      console.error('[FbtWidget] addToCart error:', err);
    } finally {
      this._addBtn.removeAttribute('aria-busy');
      this._addBtn.disabled = false;
    }
  }
}

// —— Auto-init ——————————————————————————————————————————————————

(function initFbt() {
  document.querySelectorAll('[data-fbt]').forEach(el => {
    if (!el._fbtInstance) {
      el._fbtInstance = new FbtWidget(el);
    }
  });
})();
